import { useSetAtom } from "jotai";

import { $location } from "../../internal/location/location.atom";

// This only should be used once at the top level.
export const useLocation = () => {
	const refresh = useSetAtom($location);

	return refresh;
};
